import CarouselContentAnimate from './CarouselContentAnimate.component';

export default CarouselContentAnimate;